import React, { Component } from 'react';
import { connect, getIn } from 'formik';
import Input from '../../../../components/input/text/input-formik';
import { IVirtualClassActivityAddProps, IOuterProps, IFormikProps } from '../../../../models/components/add-activity-virtualclass-content';
import { DatetimeFormik } from '../../../../components/input/date-time/date-time-formik';
import { Quil } from '../../../../components/input/quil/main';
import { SelectAsync, SelectNoneAsync } from '../../../../components/input/select/main';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import FileUpload from '../../../../components/file-upload/main';
import { Log } from 'ng2-logger';
import Translator from '../../../../core/i18n';
import { VirtualClassType } from '../../../../models/enums/VirtualClassType';
import { Confirm } from '../../../../components/notification/main';
import Switch from 'react-switch';
import { Common } from '../../../../core/common';
import { ActivityTypeEnums } from '../../../../models/enums/ActivityType';
import moment from 'moment';
import ApiClient from '../../../../api/alms-api';
import { IVirtualClassTypeList } from '../../../../models/action/virtualClass';
import Tooltip from '../../../../components/tooltip/main';

const T = Translator.create();
const _logger = Log.create('profile-tabpanel');
const token: any = localStorage.getItem('access_token');
let _common: Common;
let _apiClient: ApiClient;
let selectOptions: IVirtualClassTypeList[];

export class VirtualClassActivityContent extends Component<IFormikProps> {
    _deletedFilesId = this.props.formik.values.deletedFilesId;

    public state = {
        isModelOpen: false,
        options: []
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
        _apiClient = new ApiClient();
    }

    componentDidMount() {
        this.getOptions();
    }

    public onClickDeleteFile = (fileId: string, fileName: string) => {
        Confirm.setConfirm('normal', () => this.deleteFile(fileId, fileName), T.t('r_delete_file_question'), null);
    };

    public deleteFile = (fileId: string, fileName: string) => {
        this.setState({ isModelOpen: true });
        this._deletedFilesId.push(fileId);
        this.props.formik.setFieldValue('deletedFilesId', this._deletedFilesId);
        const fileDiv = document.getElementById(fileName);
        if (fileDiv) {
            fileDiv.classList.add('fadeOut');
            fileDiv.classList.add('animated');
            fileDiv.classList.add('hide');
            setTimeout(() => {
                if (fileDiv.parentNode) fileDiv.parentNode.removeChild(fileDiv);
            }, 1000);
        }
    };

    setDescription = (e: any) => {
        this.props.formik.setFieldValue('description', e);
    };

    public timingControl = (type: number) => {
        this.props.formik.values.dateCriteria === type
            ? this.props.formik.setFieldValue('dateCriteria', -1)
            : this.props.formik.setFieldValue('dateCriteria', type);
    };

    public clickToDownload = (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            _common.DownloadLink(filepath + '/download', fileName);
        }
    };

    handleDatePrerequisiteActivityId = (selectedValue: any) => {
        this.props.formik.setFieldValue('datePrerequisiteActivityId', selectedValue.value);
        this.props.formik.values.datePrerequisiteActivityId = selectedValue.value;
    }

    public momentParse = (_date: String, _time: String) => {
        // _date 15.02.2022 -> 2022-02-15
        // _time 23:59 -> 23:59:00
        // fullDatetime -> 2022-02-15 23:59:00

        const splited = _date.split('.');
        let date = '';
        for (let i = splited.length - 1; i >= 0; i--) {
            date += splited[i] + '-';
        }
        date = date.substring(0, date.length - 1);

        let fullDatetime = date + ' ' + _time + ':00';
        return fullDatetime;
    };

    public isPastVirtualClassActivity() {
        return (
            this.props.isUpdate &&
            moment(
                this.momentParse(getIn(this.props.formik.values, 'actualStartTime'), getIn(this.props.formik.values, 'startTimeHour'))
            ).isBefore(moment().format('YYYY-MM-DD HH:mm:ss'))
        );
    }

    public getOptions = async () => {
        const returnApi = await _apiClient
            .RequestAsync(
                "get",
                'api/virtualclass/getvirtualclasstypes',
                null,
                token,
                false,
                0,
            )
            .then((responseData: Response) => {
                if (responseData.status !== 200) {

                }
                return responseData.json();
            })
            .then((result: any) => {
                let options = [];
                if (result != null && result.length > 0) {
                    options = result;
                    selectOptions = result;
                } else {
                    selectOptions = [];
                }
                return options;
            })
            .catch(response => {
                this.setState(this.state);
                return [];
            });
        await this.setOptions()
        return returnApi;
    };

    public setOptions = () => {
        if (selectOptions && selectOptions.length > 0) {
            this.setState({
                options: [...selectOptions]
            })
        }
    }


    renderVirtualClassStartTime = () => {
        return (
            <> <h5 className="input-label mx-0">{T.t('r_start_time')}</h5><div className="d-md-flex align-items-md-end delivery-date" style={{ marginTop: 0 }}>
                <div className="row" id="virtual_class_start_date" style={{ marginTop: 0 }}>
                    <div className="col-md-6">
                        <div className="form-input form-group date-picker mb-md-0">
                            <DatetimeFormik
                                name={'actualStartTime'}
                                dateFormat={this.props.dateFormat}
                                formik={this.props.formik}
                                placeHolder={T.t('r_datetime_picker_date')}
                                datePickerId={'addActualStartTime'}
                                mode="single"
                                static={true}
                                activityType={this.props.activityType}
                                className={this.props.isUpdate && this.isPastVirtualClassActivity()
                                    ? 'form-input form-group date-picker touch-disabled'
                                    : 'form-input form-group date-picker'} // !this.props.coursePageActivityId // input -> readOnly={true}
                                minDate={new Date()}
                            />
                        </div>
                    </div>
                    <div className="col-md-6" style={{ marginTop: 0 }}>
                        <div className="form-input form-group date-picker mb-md-0 ml-md-4 mr-md-4">
                            <DatetimeFormik
                                name={'startTimeHour'}
                                formik={this.props.formik}
                                datePickerId={'addStartTimeHour'}
                                placeHolder={T.t('r_time')}
                                mode="time"
                                time24Hr={true}
                                activityType={this.props.activityType}
                                className={this.props.isUpdate && this.isPastVirtualClassActivity()
                                    ? 'form-input form-group date-picker touch-disabled'
                                    : 'form-input form-group date-picker'} />
                        </div>
                    </div>
                </div>
            </div></>
        )
    }

    virtualClassTypeSelect = () => {
        let isPerculusActive = this.state.options.filter((x: { value: number, label: string }) => x.label === 'Perculus Plus').length > 0
        let defaultValue = isPerculusActive ? VirtualClassType.PerculusPlus : VirtualClassType.Zoom;

        return (
            <div
                style={{
                    display: (this.props.isUpdate || this.state.options.length < 2) ? 'none' : 'block'
                }}
            >
                 <h5 className="input-label mx-0">{T.t('r_virtual_class_type')}</h5>
                <div className="row row-select">
                    <SelectAsync
                        isMulti={false}
                        isSearchable={false}
                        requestType={'get'}
                        placeHolder={T.t('r_make_select')}
                        url={'api/virtualclass/getvirtualclasstypes'}
                        closeMenuOnScroll={false}
                        closeMenuOnSelect={true}
                        setSelectValue={this.props.isUpdate ? this.props.formik.values.virtualClassType : defaultValue}
                        name={'virtualClassType'}
                        value={this.props.formik.values.virtualClassType ? this.props.formik.values.virtualClassType : defaultValue}
                        onChange={this.props.formik.handleChange}
                        setFieldValue={this.props.formik.setFieldValue}
                        errors={this.props.formik.errors.virtualClassType}
                        touched={this.props.formik.touched.virtualClassType}
                        isTouched={this.props.formik.setFieldTouched}
                        isDisabled={false}
                        selectedOption={isPerculusActive ? [{ value: VirtualClassType.PerculusPlus.toString(), label: 'Perculus Plus' }] : [{ value: VirtualClassType.Zoom.toString(), label: 'Zoom' }]}
                        setFieldOnlyValue={true}
                    />
                </div>
            </div>
        )
    }

    renderFileUpload = () => {
        return (
            this.props.formik.values.file && this.state.isModelOpen === false ? (
                ''
            ) : (
                <>
                     <h5 className="input-label mx-0">{T.t('r_fileUpload_dashboardTitle')}</h5>
                    <div className="upload-image text-center mb-1">
                        <FileUpload
                            key={this.props.fileInputKey}
                            fileInputKey={this.props.fileInputKey!}
                            height={300}
                            maxFileSize={2000000000}
                            maxSelectedFileCount={1}
                            isCardImage={false}
                            activityType={ActivityTypeEnums.VirtualClass}
                            files={this.props.formik.values.file}
                        />
                    </div>
                </>
            )
        )
    }

    renderFiles = () => {
        return (
            this.props.formik.values.file
                ? this.props.formik.values.file.map((file: any) => {
                    return (
                        <div
                            key={file.fileName}
                            id={file.fileName}
                            className="row"
                            style={{ paddingLeft: '15px', paddingRight: '15px', marginTop: '10px' }}
                        >
                            <p>
                                <b>{T.t('r_file')} </b>
                                <a
                                    target="_blank"
                                    title={file.fileName}
                                    style={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '90%'
                                    }}
                                    onClick={this.clickToDownload}
                                    data-filepath={file && file.filePath}
                                    data-filename={file && file.fileName}
                                >
                                    {file.fileName}
                                </a>
                            </p>
                            <i
                                // tslint:disable-next-line
                                onClick={() => this.onClickDeleteFile(file.fileId, file.fileName)}
                                className="material-icons del-icon del-icon-color"
                                style={{ marginLeft: 'auto', cursor: 'pointer' }}
                            >
                                delete
                            </i>
                        </div>
                    );
                })
                : ''
        )
    }

    renderVirtualClassTimeAndPreperationTime = () => {
        return (
            <div className="d-md-flex align-items-md-end delivery-date" style={{ marginTop: 0 }}>
                <div className="row">
                    <div className="col-md-6">
                        <Input
                            type={'number'}
                            className={
                                this.props.isUpdate && this.isPastVirtualClassActivity()
                                    ? 'form-input form-group date-picker mb-md-0 touch-disabled'
                                    : 'form-input form-group date-picker mb-md-0'
                            }
                            name={'virtualClassTime'}
                            // label={T.t('r_validation_gen_virtualClassTime')}
                            placeHolder={T.t('r_validation_gen_virtualClassTime')}
                            formik={this.props.formik}
                        />
                    </div>
                    <div className="col-md-6">
                        <Input
                            type={'number'}
                            min={0}
                            className={
                                this.props.isUpdate && this.isPastVirtualClassActivity()
                                    ? 'form-input form-group date-picker mb-md-0 ml-md-4 mr-md-4 touch-disabled'
                                    : 'form-input form-group date-picker mb-md-0 ml-md-4 mr-md-4'
                            }
                            name={'preparationTime'}
                            // label={T.t('r_validation_gen_preparationTime')}
                            placeHolder={T.t('r_validation_gen_preparationTime')}
                            formik={this.props.formik}
                        />
                    </div>
                </div>
            </div>
        )
    }
    renderDatePicker = (nameParam: string, id: string, minDateParam?: any, maxDateParam?: any) => {
        return (
            <div className="col-md-6">
                <div className="form-input form-group date-picker mb-md-0">
                    <DatetimeFormik
                        minDate={minDateParam ?? undefined}
                        maxDate={maxDateParam ?? undefined}
                        name={nameParam}
                        dateFormat={this.props.dateFormat}
                        formik={this.props.formik}
                        placeHolder={T.t('r_datetime_picker_date')}
                        datePickerId={id}
                        mode="single"
                        dataClearable={true}
                        static={true}
                        activityType={this.props.activityType}
                    />
                </div>
            </div>
        )
    }

    renderTimePicker = (nameParam: string, id: string) => {
        return (
            <div className="col-md-6">
                <div className="form-input form-group date-picker mb-md-0 ml-md-4 mr-md-4">
                    <DatetimeFormik
                        name={nameParam}
                        formik={this.props.formik}
                        datePickerId={id}
                        placeHolder={T.t('r_time')}
                        mode="time"
                        time24Hr={true}
                        dataClearable={true}
                        static={true}
                        activityType={this.props.activityType}
                    />
                </div>
            </div>
        )
    }

    displayByDateSettings = () => {
        return (
            <div
                style={{
                    display: this.props.formik.values.dateCriteria === 1 ? 'block' : 'none'
                }}
            >
                 <h5 className="input-label mx-0">{T.t('r_show_after_date')}</h5>
                <div className="d-md-flex align-items-md-end delivery-date" style={{ marginTop: 0 }}>
                    <div className="row" id="assignment_by_begin_date" style={{ marginTop: 0 }}>
                        {this.renderDatePicker('activityBeginDate', 'activityByBeginDate')}
                        {this.renderTimePicker('activityBeginTime', 'activityByBeginTime')}
                    </div>
                </div>
                 <h5 className="input-label mx-0">{T.t('r_dont_show_after_date')}</h5>
                <div className="d-md-flex align-items-md-end delivery-date" style={{ marginTop: 0 }}>
                    <div className="row" id="assignment_by_end_date" style={{ marginTop: 0 }}>
                        {this.renderDatePicker('activityEndDate', 'activityByEndDate')}
                        {this.renderTimePicker('activityEndTime', 'activityByEndTime')}
                    </div>
                </div>
            </div>
        )
    }

    displayByWeekSettings = () => {
        return (
            <div
                className={
                    'animated ' + (this.props.formik.values.dateCriteria === 0 ? 'fadeInDown' : 'fadeOutDown')
                }
                style={{
                    animationDuration: '0.3s',
                    display: this.props.formik.values.dateCriteria === 0 ? 'block' : 'none',
                    marginTop: '1.5rem'
                }}
            >
                {this.props.isWeekly ? (
                    <SelectAsync
                        isMulti={true}
                        isSearchable={true}
                        requestType={'post'}
                        isDisabled={!this.props.isWeekly}
                        parameter={{
                            courseId: this.props.coursePageActivityId,
                            classId: this.props.coursePageClassId,
                            isTiming: true,
                            SelectedIds: this.props.formik.values.termWeekIds,
                            activityConditionalBeginDate: this.props.formik.values.activityConditionalBeginDate
                        }}
                        placeHolder={T.t('r_select_by').replace('{0}', this.props.termType)}
                        url={'api/term/courseweeks'}
                        closeMenuOnScroll={false}
                        closeMenuOnSelect={false}
                        column={{ label: 'weekLabel', value: 'termWeekId' }}
                        setSelectValue={this.props.isUpdate ? this.props.formik.values.termWeekIds : ''}
                        name={'termWeekIds'}
                        value={this.props.formik.values.termWeekIds}
                        onChange={this.props.formik.handleChange}
                        setFieldValue={this.props.formik.setFieldValue}
                        errors={this.props.formik.errors.termWeekIds}
                        touched={this.props.formik.touched.termWeekIds}
                        isTouched={this.props.formik.setFieldTouched}
                        setFieldOnlyValue={true}
                        colourStyles={{
                            menu: () => ({ zIndex: 999999 })
                        }}
                    />
                ) : (
                    <h6 className="not-weekly-text">{T.t('r_not_weekly_course')}</h6>
                )}
            </div>
        )
    }

    displayByActivitySetings = () => {
        return (
            <div
                className={
                    'animated ' + (this.props.formik.values.dateCriteria === 2 ? 'fadeInDown' : 'fadeOutDown')
                }
                style={{
                    animationDuration: '0.3s',
                    display: this.props.formik.values.dateCriteria === 2 ? 'block' : 'none',
                    marginTop: '1.5rem'
                }}
            >
                <SelectAsync
                    isMulti={false}
                    isSearchable={true}
                    isClearable={true}
                    requestType={'post'}
                    parameter={{
                        CourseId: this.props.coursePageActivityId,
                        classId: this.props.coursePageClassId,
                        Take: 7,
                        Skip: 0,
                        activityId: this.props.isUpdate || null
                    }}
                    placeHolder={T.t('r_select_activity')}
                    url={'api/get/conditionalactivities'}
                    closeMenuOnScroll={false}
                    closeMenuOnSelect={true}
                    column={{ label: 'activityName', value: 'activityId' }}
                    setSelectValue={this.props.isUpdate ? this.props.formik.values.datePrerequisiteActivityId : ''}
                    name={'datePrerequisiteActivityId'}
                    value={this.props.formik.values.datePrerequisiteActivityId}
                    onChange={this.handleDatePrerequisiteActivityId}
                    setFieldValue={this.props.formik.setFieldValue}
                    errors={this.props.formik.errors.datePrerequisiteActivityId}
                    touched={this.props.formik.touched.datePrerequisiteActivityId}
                    isTouched={this.props.formik.setFieldTouched}
                    colourStyles={{
                        menu: () => ({ zIndex: 999999 })
                    }}
                />
            </div>
        )
    }

    renderCompletionCriteriaWhenIsNotUpdate = () => {
        if(!this.props.formik.values.virtualClassEnableReplayAfterFinish && !this.props.isUpdate)
        {
        this.props.formik.values.completionType = ActivityCompletionType.AttendLiveSession;

        }
        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="radio-tabs tick-radio position-relative">
                        <input
                            type="radio"
                            name={'completionType'}
                            value={ActivityCompletionType.AttendLiveSession}
                            defaultChecked={true}
                            onChange={this.props.formik.setFieldValue.bind(
                                this,
                                'completionType',
                                ActivityCompletionType.AttendLiveSession
                            )}
                            id="activity-one"
                            className="form-radio"
                            checked={this.props.formik.values.completionType === ActivityCompletionType.AttendLiveSession}
                        />
                        <label htmlFor="activity-one">{T.t('r_activity_virtualClass_attend_live_session')}</label>
                    </div>
                </div>
                {this.props.formik.values.virtualClassEnableReplayAfterFinish &&
                <div className="col-md-6">
                <div className="radio-tabs tick-radio position-relative">
                    <input
                        type="radio"
                        name={'completionType'}
                        value={ActivityCompletionType.ViewRecordedSession}
                        onChange={this.props.formik.setFieldValue.bind(
                            this,
                            'completionType',
                            ActivityCompletionType.ViewRecordedSession
                        )}
                        id="activity-two"
                        className="form-radio"
                        checked={this.props.formik.values.completionType === ActivityCompletionType.ViewRecordedSession && this.props.formik.values.virtualClassEnableReplayAfterFinish}
                    />
                    <label htmlFor="activity-two">{T.t('r_activity_virtualClass_view_recorded_session')}</label>
                </div>
            </div>
                }

                <div className="col-md-6" style={{ marginTop: (this.props.formik.values.virtualClassEnableReplayAfterFinish ? 10 : 0) }}>
                    <div className="radio-tabs tick-radio position-relative" style={{marginInlineEnd: "0px"}}>
                        <input
                            type="radio"
                            name={'completionType'}
                            value={ActivityCompletionType.ProgressLive}
                            onChange={this.props.formik.setFieldValue.bind(
                                this,
                                'completionType',
                                ActivityCompletionType.ProgressLive
                            )}
                            id="activity-three"
                            className="form-radio"
                            checked={this.props.formik.values.completionType === ActivityCompletionType.ProgressLive}
                        />
                        <label htmlFor="activity-three">{T.t('r_activity_virtualClass_progress_live')}</label>
                    </div>
                    <div
                        className={'animated ' + (this.props.formik.values.completionType === 9 ? 'fadeInDown' : 'fadeOutDown')}
                        style={{
                            animationDuration: '0.3s',
                            display: this.props.formik.values.completionType === 9 ? 'block' : 'none',
                            padding: '1.8%'
                        }}
                    >
                        <Input
                            type={'number'}
                            name={'completionCriteria'}
                            label={T.t('r_gen_progress')}
                            formik={this.props.formik}
                        />
                    </div>
                </div>
                {this.props.formik.values.virtualClassEnableReplayAfterFinish &&

                <div className="col-md-6" style={{ marginTop: 10 }}>
                    <div className="radio-tabs tick-radio position-relative" style={{marginInlineEnd: "0px"}}>
                        <input
                            type="radio"
                            name={'completionType'}
                            value={ActivityCompletionType.ProgressLiveOrArchive}
                            onChange={this.props.formik.setFieldValue.bind(
                                this,
                                'completionType',
                                ActivityCompletionType.ProgressLiveOrArchive
                            )}
                            id="activity-four"
                            className="form-radio"
                            checked={this.props.formik.values.completionType === ActivityCompletionType.ProgressLiveOrArchive}
                        />
                        <label htmlFor="activity-four">{T.t('r_activity_virtualClass_progress_live_or_archive')}</label>
                    </div>
                    <div
                        className={
                            'animated ' + (this.props.formik.values.completionType === 10 ? 'fadeInDown' : 'fadeOutDown')
                        }
                        style={{
                            animationDuration: '0.3s',
                            display: this.props.formik.values.completionType === 10 ? 'block' : 'none',
                            padding: '1.8%'
                        }}
                    >
                        <Input
                            type={'number'}
                            name={'completionCriteria'}
                            label={T.t('r_gen_progress')}
                            formik={this.props.formik}
                        />
                    </div>
                </div>

                    }
            </div>
        )
    }

    renderCompletionCriteriaType = (completionType: ActivityCompletionType, _id: string, label: string) => {
        return (
            <div className="radio-tabs tick-radio position-relative">
                <input
                    type="radio"
                    name={'completionType'}
                    value={completionType}
                    defaultChecked={true}
                    onChange={this.props.formik.setFieldValue.bind(
                        this,
                        'completionType',
                        completionType
                    )}
                    id={_id}
                    className="form-radio"
                    checked={this.props.formik.values.completionType === completionType}
                />
                <label htmlFor={_id}>{label}</label>
            </div>
        )
    }

    renderCompletionCriteriaSettings = () => {
        let content;
        if (this.props.formik.values.completionType === ActivityCompletionType.AttendLiveSession) {
            content = <div className="col-md-6">
                {this.renderCompletionCriteriaType(ActivityCompletionType.AttendLiveSession, "activity-one", T.t('r_activity_virtualClass_attend_live_session'))}
            </div>
        }
        else if (this.props.formik.values.completionType === ActivityCompletionType.ViewRecordedSession) {
            content = <div className="col-md-6">
                {this.renderCompletionCriteriaType(ActivityCompletionType.ViewRecordedSession, "activity-two", T.t('r_activity_virtualClass_view_recorded_session'))}
            </div>
        }
        else if (this.props.formik.values.completionType === ActivityCompletionType.ProgressLive) {
            content = <div className="col-md-6" style={{ marginTop: 10 }}>
                {this.renderCompletionCriteriaType(ActivityCompletionType.ProgressLive, "activity-three", T.t('r_activity_virtualClass_progress_live'))}
                <div
                    className={'animated ' + (this.props.formik.values.completionType === 9 ? 'fadeInDown' : 'fadeOutDown')}
                    style={{
                        animationDuration: '0.3s',
                        display: this.props.formik.values.completionType === 9 ? 'block' : 'none',
                        padding: '1.8%'
                    }}
                >
                    <Input
                        type={'number'}
                        name={'completionCriteria'}
                        label={T.t('r_gen_progress')}
                        formik={this.props.formik}
                    />
                </div>
            </div>
        }
        else if (this.props.formik.values.completionType === ActivityCompletionType.ProgressLiveOrArchive) {
            content = <div className="col-md-6" style={{ marginTop: 10 }}>
                {this.renderCompletionCriteriaType(ActivityCompletionType.ProgressLiveOrArchive, "activity-four", T.t('r_activity_virtualClass_progress_live_or_archive'))}
                <div
                    className={
                        'animated ' + (this.props.formik.values.completionType === 10 ? 'fadeInDown' : 'fadeOutDown')
                    }
                    style={{
                        animationDuration: '0.3s',
                        display: this.props.formik.values.completionType === 10 ? 'block' : 'none',
                        padding: '1.8%'
                    }}
                >
                    <Input
                        type={'number'}
                        name={'completionCriteria'}
                        label={T.t('r_gen_progress')}
                        formik={this.props.formik}
                    />
                </div>
            </div>
        }
        else {
            content = null;
        }
        return (
            this.props && this.props.isUpdate != ""
                ?
                <div className="row">
                    {content}
                </div>
                :
                this.renderCompletionCriteriaWhenIsNotUpdate()
        )
    }

    public render() {
        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_contentTab' ? ' show active' : '')}
                style={{ display: this.props.currentTab === '_contentTab' ? 'block' : 'none' }}
                id="video-setting"
                role="tabpanel"
                aria-labelledby="video-setting-tab"
            >
                 <h5 className="input-label mx-0">{T.t('r_activity_search_placeholder')}<span className="ml-1" style={{ color: '#dc5050' }}>*</span></h5>
                <Input type={'text'} name={'name'} placeHolder={T.t('r_activity_search_placeholder')} formik={this.props.formik} />
                <p className="half-color">{T.t('r_activity_list_shown_text')}</p>
                 <h5 className="input-label mx-0">{T.t('r_Instructor_note_description')}</h5>
                <Quil
                    modules={'basic'}
                    placeholder={T.t('r_write_description_for_activity')}
                    onChange={this.setDescription}
                    value={this.props.formik.values.description}
                    theme={'snow'}
                />
                {this.renderFileUpload()}
                {this.renderFiles()}

                {!this.props.isProjectSubActivity && (
                    <>
                        <div className='d-flex align-items-center mt-3'>
                             <h5 className="input-label mx-0">{T.t('r_timing')}</h5>
                            <Tooltip data={T.t('r_timing_info')} position='bottom'>
                                <img src={_common.GetDefaultIcons('info')} style={{ width: '1em',height:'1em', marginInlineStart: "8px" }} alt="" />
                            </Tooltip>
                        </div>
                        <div className="row">
                            {this.props.isWeekly && (
                                <div className="col-md-4">
                                    <div
                                        className={
                                            'radio-tabs tick-radio position-relative'
                                        }
                                    >
                                        <input
                                            type="checkbox"
                                            name={'dateCriteria'}
                                            onChange={this.timingControl.bind(this, 0)}
                                            value={0}
                                            id="time-zero"
                                            className="form-radio"
                                            checked={this.props.formik.values.dateCriteria === 0}
                                            style={{ borderRadius: 100 }}
                                        />
                                        <label htmlFor="time-zero" style={{ marginInlineStart: "6px" }}>
                                            {T.t('r_show_by').replace('{0}', this.props.termType)}
                                        </label>
                                    </div>
                                </div>
                            )}
                            <div className="col-md-4">
                                <div
                                    className={
                                        'radio-tabs tick-radio position-relative'
                                    }
                                >
                                    <input
                                        type="checkbox"
                                        name={'dateCriteria'}
                                        onChange={this.timingControl.bind(this, 1)}
                                        value={1}
                                        id="time-one"
                                        className="form-radio"
                                        checked={this.props.formik.values.dateCriteria === 1}
                                        style={{ borderRadius: 100 }}
                                    />
                                    <label htmlFor="time-one" style={{ marginInlineStart: "6px" }}>{T.t('r_publish_by_date')}</label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div
                                    className={
                                        'radio-tabs tick-radio position-relative'
                                    }
                                >
                                    <input
                                        type="checkbox"
                                        name={'dateCriteria'}
                                        onChange={this.timingControl.bind(this, 2)}
                                        value={2}
                                        id="time-two"
                                        className="form-radio"
                                        checked={this.props.formik.values.dateCriteria === 2}
                                        style={{ borderRadius: 100 }}
                                    />
                                    <label htmlFor="time-two" style={{ marginInlineStart: "6px" }}>{T.t('r_show_by_another_activity')}</label>
                                </div>
                            </div>
                        </div>
                        <div className="row" id="virtual_class_publish_date" style={{ marginTop: 0 }}>
                            <div className="col-md-6">
                                {this.displayByDateSettings()}
                                {this.displayByWeekSettings()}
                                {this.displayByActivitySetings()}
                            </div>
                            <div
                                className={
                                    'animated ' + (this.props.formik.values.dateCriteria === 2 ? 'fadeInDown' : 'fadeOutDown')
                                }
                                style={{
                                    animationDuration: '0.3s',
                                    display: 'none',
                                    padding: '1.8%'
                                }}
                            >
                                <Input
                                    type={'number'}
                                    name={'datePrerequisiteActivityHours'}
                                    label={T.t('r_time')}
                                    formik={this.props.formik}
                                    value={'0'}
                                />
                            </div>
                        </div>
                    </>
                )}
                {this.virtualClassTypeSelect()}

                {this.renderVirtualClassStartTime()}

                {this.renderVirtualClassTimeAndPreperationTime()}

                {!this.props.isProjectSubActivity && (
                    <>
                        <React.Fragment>
                            <div className='d-flex align-items-center'>
                             <h5 className="input-label mx-0">{T.t('r_activity_virtualClass_enable_replay_after_finish')}</h5>
                            <Tooltip data={T.t('r_virtuel_class_save_info')} position='top'>
                                <img src={_common.GetDefaultIcons('info')} style={{ width: '1em',height:'1em', marginInlineStart: "8px"  }} alt="" />
                            </Tooltip>
                            </div>
                            <div
                                className={
                                    this.props.isUpdate && this.isPastVirtualClassActivity()
                                        ? 'col-sm-2 tick-radio text-md-right mt-3 touch-disabled'
                                        : 'col-sm-2 tick-radio text-md-right mt-3'
                                }
                                style={{ paddingLeft: 0 }}
                            >
                                <Switch
                                    id={'check-onTop'}
                                    name={'virtualClassEnableReplayAfterFinish'}
                                    // tslint:disable-next-line:jsx-no-lambda
                                    onChange={(e: any) => this.props.formik.setFieldValue('virtualClassEnableReplayAfterFinish', e)}
                                    checked={this.props.formik.values.virtualClassEnableReplayAfterFinish}
                                    defaultChecked={true}
                                    onColor="#358730"
                                    onHandleColor="#358730"
                                    handleDiameter={30}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    height={20}
                                    width={48}
                                    className="react-switch"
                                />
                                <label htmlFor="check-onTop" className='word-break-unset mx-2 my-0' style={{marginInlineStart: "5px"}}>
                                    {this.props.formik.values.virtualClassEnableReplayAfterFinish ? T.t('r_yes') : T.t('r_no')}
                                </label>
                            </div>
                        </React.Fragment>
                        <div className='d-flex align-items-center'>
                             <h5 className="input-label mx-0">{T.t('r_activity_finish_criteria')}</h5>
                            <Tooltip data={T.t('r_activity_finish_criteria_info')} position='top' heightValue='2em'>
                                <img src={_common.GetDefaultIcons('info')} style={{ width: '1em',height:'1em', marginInlineStart: "8px"  }} alt="" />
                            </Tooltip>
                        </div>
                        {this.renderCompletionCriteriaSettings()}

                        {this.props.isWeekly && (
                            <>
                                 <h5 className="input-label mx-0">{T.t('r_activity_deadline_criteria')}</h5>
                                <div className="d-md-flex align-items-md-end delivery-date" style={{ marginTop: 0 }}>
                                    <div className="row" id="virtual_class_end_date" style={{ marginTop: 0 }}>
                                        {this.renderDatePicker('taskDeadline', 'addActivityDate', moment(this.props.courseStartDate).format("YYYY-MM-DD"), moment(this.props.courseEndDate).format("YYYY-MM-DD"))}
                                        {this.renderTimePicker('taskDeadlinetime', 'addActivityTime')}
                                    </div>
                                </div>
                            </>
                        )}

                    </>
                )}
            </div>
        );
    }
}

export default connect<IVirtualClassActivityAddProps, IOuterProps>(VirtualClassActivityContent);
